import {observable} from 'mobx';
import {Language} from './language';
import {ModelProperties, createInstance} from 'utils';

export class UserTranslator {
    @observable id!: number;

    @observable userId!: number;

    @observable assignedLanguageId!: number;

    @observable assignedLanguage?: Language;

    @observable allowAllLanguages?: boolean;

    constructor(translator?: ModelProperties<UserTranslator>) {
        if (translator) {
            Object.assign(this, translator);
            this.assignedLanguage = createInstance(Language, translator.assignedLanguage);
        }
    }
}